import axios from 'axios';
import humps from 'humps';

const API_URL = 'https://reddentis-map-api.herokuapp.com/api';

const createAxiosClient = () => {
  const client = axios.create({
    baseURL: API_URL,
    transformRequest: [
      data => humps.decamelizeKeys(data),
      ...axios.defaults.transformRequest,
    ],
    transformResponse: [
      ...axios.defaults.transformResponse,
      data => humps.camelizeKeys(data),
    ]
  });

  return client;
}

export default createAxiosClient;
